function isMobile() {
  var userAgentInfo = navigator.userAgent;
  var mobileAgents = [
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod",
  ];
  var mobile_flag = false;
  //根据userAgent判断是否是手机
  for (var v = 0; v < mobileAgents.length; v++) {
    if (userAgentInfo.indexOf(mobileAgents[v]) > 0) {
      mobile_flag = true;
      break;
    }
  }
  var screen_width = window.screen.width;
  var screen_height = window.screen.height;
  //根据屏幕分辨率判断是否是手机
  if (screen_width < 500 && screen_height < 800) {
    mobile_flag = true;
  }
  return mobile_flag;
}

function addAjax(data, val) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function (msg, val) {
        resolve(true);
      },
      error: function (xhr, text) {
        reject(false);
        alert($.parseJSON(xhr.responseText).description);
      },
    });
  });
}

function getSizes(arr) {
  var obj = {};

  arr.forEach((newAr, index) => {
    // init with array if the key is falsy (undefined in this case)
    obj[newAr] = obj[newAr] || [];

    // push the current index into the array
    obj[newAr].push(index);
  });

  return obj;
}

//   通过阿里云生成图片地址
async function buildImg() {
  const img = $(".ymq_img_item");
  if (!img) {
    return false;
  }
  let bloburl = img.attr("src");
  if (!bloburl) {
    return false;
  }
  let file = await fetch(bloburl).then((res) => res.blob());
  var client = new OSS({
    region: "oss-us-west-1", //你的oss地址 ，具体位置见下图
    accessKeyId: "LTAI5tC7havbcJhq4GdqLFcn", //你的ak
    accessKeySecret: "3gT45QLbmqgxHUKidtD4Gj0h6ArFqK", //你的secret
    //stsToken: '<Your securityToken(STS)>',//这里我暂时没用，注销掉
    bucket: "cikersbaseball", //你的oss名字
    secure: true,
  });
  console.log(file);
  const filename =
    "logo" + new Date().getTime() + Math.round(Math.random() * 1000);
  const res = await client.put(filename, file);
  return res?.url;
}

function includeOf(orign, str) {
  if (typeof orign === "string" && typeof str === "string") {
    return orign.indexOf(str) > -1;
  }
  return false;
}

/*
[
    {
        "name": "properties[Type]",
        "value": "Men"
    },
    {
        "name": "properties[Step 1: Choose a decoration option]",
        "value": " Standard"
    },
    {
        "name": "properties[Step 2:Team Information]",
        "value": "Team Name, Player Number, Logo, Sponsor"
    },
    {
        "name": "properties[Team Name]",
        "value": "asaasa"
    },
    {
        "name": "properties[Player Number Option]",
        "value": "Both Sides"
    },
    {
        "name": "properties[Sponsor Option]",
        "value": "Sponsor Imge"
    },
    {
        "name": "properties[Sponsor Location]",
        "value": "2.Front Belly (Low Position) "
    },
    {
        "name": "properties[Number of Players]",
        "value": "2"
    },
    {
        "name": "properties[Size-1-19]",
        "value": "S"
    },
    {
        "name": "properties[Player 1 Name]",
        "value": "cc"
    },
    {
        "name": "properties[Number-1-22]",
        "value": "11"
    },
    {
        "name": "properties[Size-1-42]",
        "value": "M"
    },
    {
        "name": "properties[Player 2 Name]",
        "value": "aa"
    },
    {
        "name": "properties[Number-1-76]",
        "value": "22"
    },
    {
        "name": "properties[ Step 4:Special requirements and additional notes]",
        "value": "aasas"
    }
]
*/

// 转换表单选项名称    properties[Team Name]   ===》 Team Name
function getOptName(params) {
  const reg_player_name = RegExp(/Player [0-9]/);
  if (includeOf(params, "decoration")) {
    return "properties[decoration option]";
  }
  if (includeOf(params, "requirements")) {
    return "properties[requirements]";
  }
  // if (includeOf(params, "Size")) {
  //   return "properties[Size]";
  // }
  // if (includeOf(params, "Number-")) {
  //   return "properties[Player Number]";
  // }
  // if (reg_player_name.test(params)) {
  //   return "properties[Player Name]";
  // }
  return params;
}

// 收集团队信息
function getOption(formdata) {
  let quantityArr = [];
  let params = "";

  const options = formdata.filter((item) => {
    return (
      !includeOf(item.name, "empty-properties") &&
      includeOf(item.name, "properties") &&
      !includeOf(item.name, "Team Information")
    );
  });

  options.map(function (item) {
    const opname = getOptName(item.name);
    if (includeOf(opname, "Size")) {
      params = params + "|&" + opname + "=" + item.value;
      quantityArr.push(item.value);
    } else {
      params += "&" + opname + "=" + item.value;
    }
  });

  return [params, quantityArr];
}

function getFieldValue(field, formdata) {
  const result = formdata.find((item) => includeOf(item.name, field));
  return result?.value;
}

// ymq[Step 2:Team Information]  校验logo  value  包含 'Logo'

function loading(flag) {
  const btn = $("#add-to-cart button");
  if (flag) {
    btn.addClass("loading");
  } else {
    btn.removeClass("loading");
  }
}

function getQuote() {
  location.href = "/pages/contact-us";
}

async function addCartFun(e) {
  const formData = $(".productView-buttons .installment").serializeArray();
  const clothType = getFieldValue("decoration", formData);
  if (includeOf(clothType, "Bespoke")) {
    getQuote();
    return;
  }
  const prod_options = Array.from($(".product-option .product-form__input")).filter(item=>!$(item).hasClass('mobile'))
  const color = $(prod_options[0]).find(".form__label span").text();
  const gender = $(prod_options[2]).find(".form__label span").text();

  console.log("forminfo color===>", color);
  const forminfo = getOption(formData);
  console.log("forminfo===>", forminfo);

  
  const optionInfo = forminfo[0];
  const sizeArr = forminfo[1];
  const sizeObj = getSizes(sizeArr);
  // const addTimes = sizeArr.length;
  const addTimes = Object.keys(sizeObj);
  const teamValue = getFieldValue("Team Information", formData);
  const numbers = getFieldValue("Number of Players", formData);
  const logoUrl = await buildImg();

  if (!color) {
    alert("Please choose your color!");
    return;
  }

  if (!sizeArr?.length || sizeArr.length != numbers) {
    alert("Please choose your size!");
    return;
  }

  // 若勾选logo没有上传则提示
  if (includeOf(teamValue, "Logo") && !logoUrl) {
    alert("please upload your logo file！");
    return;
  }

  let datas = "";
  let res = false;
  let pinfo = "";
  const infoArr = optionInfo.split("|");
  loading(true);
  for (let i = 0; i < addTimes.length; i++) {
    let currentSize = addTimes[i];
    let variantId = "";
    let getVariantId = cart_variants.filter((item) => {
      const nogender = item.option1 == color && item.option2 == currentSize;
      const hasgender =
        item.option1 == color &&
        item.option2 == currentSize &&
        item.option3 === gender;
      if (gender) {
        return hasgender;
      } else {
        return nogender;
      }
    });

    if (getVariantId.length > 0) {
      variantId = getVariantId[0].id;
    } else {
      alert("Please choose your size");
      break;
    }
    if (sizeObj[addTimes[i]]) {
      const indexArr = sizeObj[addTimes[i]];
      pinfo = infoArr[0];
      for (let j = 0; j < infoArr.length; j++) {
        if (infoArr[indexArr[j] + 1]) {
          pinfo += infoArr[indexArr[j] + 1];
        }
      }
    }

    // console.log(strs);
    const quantity = sizeObj[addTimes[i]].length;
    const baseinfo = `&quantity=${quantity}&id=${variantId}${pinfo}`;
    if (logoUrl) {
      datas = `${baseinfo}&properties[logo]=${logoUrl}`;
    } else {
      datas = baseinfo;
    }
    // return;
    res = await addAjax(datas, true);
  }

  return res;
}

// 原生商品表单提交验证
async function addCartOrign() {
  const formData = $(".product-form_cart").serializeArray();

  const prod_options = Array.from($(".product-option .product-form__input")).filter(item=>!$(item).hasClass('mobile'))
  const cur_color = $(prod_options[0]).find(".form__label span").text();
  const cur_size = $(prod_options[1]).find(".form__label span").text();
  const gender = $(prod_options[2]).find(".form__label span").text();
  
   // const cur_color = $(".productView-options .product-form__radio").eq(0).val();
  // const cur_size = $(".productView-options .product-form__radio").eq(1).val();
  // const gender = $(".productView-options .product-form__radio").eq(2).val();
  
  const quantity = getFieldValue("quantity", formData);
  console.log("formData ===>", formData);
  if (!cur_color) {
    alert("Please choose your color!");
    return;
  }
  if (!cur_size) {
    alert("Please choose your size!");
    return;
  }
  loading(true);

  const selectVar = cart_variants.filter((item) => {
    const nogender = item.option1 == cur_color && item.option2 == cur_size;
    const hasgender =
      item.option1 == cur_color &&
      item.option2 == cur_size &&
      item.option3 === gender;
    if (gender) {
      return hasgender;
    } else {
      return nogender;
    }
  });

  const datas = "&quantity=" + quantity + "&id=" + selectVar[0].id;
  return await addAjax(datas, true);
}

// 若ymqbox没加载，调用原生表单方法
async function addCart(e) {
  const ymqbox = document.getElementById("ymq-box");
  let res = false;
  if (ymqbox) {
    res = await addCartFun(e);
  } else {
    res = await addCartOrign();
  }
  if (!res) {
    loading(false);
    return;
  }

  setTimeout(function () {
    window.location.href = "/cart";
  }, 500);
}

// 初始商品表单
function initProduct() {
  // ymq插件
  const ymqbox = document.getElementById("ymq-box");
  // 商品数量
  const quantity = $(".productView-quantity");
  const kiwiSize = $(".product-option .product-form__input").eq(1);
  // 插件存在，隐藏原始表单
  if (ymqbox) {
    quantity.hide();
    $(kiwiSize).hide();
  }
  setTimeout(function () {
    $(".product-form_cart").on("submit", function (e) {
      e.preventDefault();
    });
  }, 500);
}

// 所有插件加载完成后初始商品表单
document.onreadystatechange = function () {
  if (document.readyState == "complete") {
    initProduct();
    initFieldChange();
  }
};

// 根据type 切换加购按钮
function changeCartBtn(type) {
  if (includeOf(type, "Bespoke")) {
    $("#add-to-cart span").text("Get A Quote");
  }
  if (includeOf(type, "Standard")) {
    $("#add-to-cart span").text("Add to Cart");
  }
}

function initFieldChange() {
  const ymqbox = document.getElementById("ymq-box");
  if (!ymqbox) {
    return;
  }
  const formcart = $(".product-form_cart");
  const form_type = $(ymqbox).find(
    "input[name='ymq[Step 1: Choose a decoration option]']:checked"
  );
  let cloth_type = form_type.val();
  changeCartBtn(cloth_type);
  formcart.attr("action", "#");
  $(ymqbox)
    .find(".ymq-options-box")
    .eq(0)
    .on("change", function (e) {
      const cur_type = $(this).find(
        "input[name='ymq[Step 1: Choose a decoration option]']:checked"
      );
      cloth_type = cur_type.val();
      console.log("cloth_type,===>", cloth_type);
      changeCartBtn(cloth_type);
    });
}
